// Re-export from the canonical source in ui-ds-base
export { Alert, alertVariants, alertTextVariants } from '@restworld/ui-ds-base';
export type { AlertProps } from '@restworld/ui-ds-base';
